import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Field, Checkbox } from "./Categories";

const emptyProduct = {
  categoryId: "", nameTR: "", nameEN: "", shortDescriptionTR: "", shortDescriptionEN: "",
  longDescriptionTR: "", longDescriptionEN: "", image: "", gallery: [], price: 0, discountedPrice: null,
  currency: "₺", isActive: true, isAvailable: true, isPopular: false, isChefRecommended: false,
  isNew: false, isVegan: false, isVegetarian: false, isGlutenFree: false, isSpicy: false,
  allergensTR: "", allergensEN: "", ingredientsTR: "", ingredientsEN: "", portionInfo: "",
  preparationTime: "", sortOrder: 0, variants: [], extras: [], seoTitle: "", seoDescription: "",
};

const Products = () => {
  const [list, setList] = useState([]);
  const [cats, setCats] = useState([]);
  const [filter, setFilter] = useState("all");
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const load = () => Promise.all([api.get("/products"), api.get("/categories")]).then(([p, c]) => {
    setList(p.data); setCats(c.data);
  });
  useEffect(() => { load(); }, []);

  const filtered = filter === "all" ? list : list.filter((p) => p.categoryId === filter);

  const save = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...editing, price: parseFloat(editing.price) || 0, discountedPrice: editing.discountedPrice ? parseFloat(editing.discountedPrice) : null };
      if (editing.id) await api.put(`/products/${editing.id}`, payload);
      else await api.post("/products", payload);
      toast.success("Kaydedildi"); setShowForm(false); setEditing(null); load();
    } catch (e) { toast.error("Hata"); }
  };

  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/products/${id}`); toast.success("Silindi"); load();
  };

  const toggleActive = async (p) => {
    await api.put(`/products/${p.id}`, { ...p, isActive: !p.isActive });
    load();
  };

  return (
    <div className="space-y-6" data-testid="products-page">
      <header className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-serif text-3xl text-zbeach-dark">Ürünler</h1>
          <p className="text-zbeach-muted text-sm mt-1">Menü ürünlerini ekleyin, düzenleyin.</p>
        </div>
        <div className="flex items-center gap-3">
          <select value={filter} onChange={(e) => setFilter(e.target.value)} className="px-3 py-2 rounded-full bg-zbeach-surface border border-zbeach-gold/20 text-sm" data-testid="filter-cat">
            <option value="all">Tüm Kategoriler</option>
            {cats.map((c) => <option key={c.id} value={c.id}>{c.nameTR}</option>)}
          </select>
          <button onClick={() => { setEditing({ ...emptyProduct, categoryId: cats[0]?.id || "", sortOrder: list.length }); setShowForm(true); }}
            className="px-4 py-2.5 rounded-full bg-zbeach-turquoise text-white font-medium text-sm btn-glow" data-testid="product-add-btn">
            <i className="fa-solid fa-plus mr-1" /> Yeni Ürün
          </button>
        </div>
      </header>

      <div className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[800px]">
          <thead className="bg-zbeach-bg text-zbeach-muted uppercase text-xs tracking-wider">
            <tr><th className="text-left p-3">Görsel</th><th className="text-left p-3">Ad</th><th className="text-left p-3">Kategori</th><th className="text-left p-3">Fiyat</th><th className="text-left p-3">Durum</th><th className="text-left p-3">Rozet</th><th className="text-right p-3">İşlem</th></tr>
          </thead>
          <tbody>
            {filtered.map((p) => {
              const cat = cats.find((c) => c.id === p.categoryId);
              return (
                <tr key={p.id} className="border-t border-zbeach-gold/10" data-testid={`product-row-${p.id}`}>
                  <td className="p-3">
                    <div className="w-12 h-12 rounded-lg bg-zbeach-sand overflow-hidden">
                      {p.image && <img src={p.image} alt="" className="w-full h-full object-cover" />}
                    </div>
                  </td>
                  <td className="p-3 font-medium">{p.nameTR}</td>
                  <td className="p-3 text-zbeach-muted">{cat?.nameTR || "-"}</td>
                  <td className="p-3 font-medium text-gold-gradient">{p.price} {p.currency}</td>
                  <td className="p-3">
                    <button onClick={() => toggleActive(p)} className="text-xs">
                      {p.isActive ? <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700">Aktif</span> : <span className="px-2 py-0.5 rounded-full bg-zbeach-muted/15 text-zbeach-muted">Pasif</span>}
                    </button>
                  </td>
                  <td className="p-3 space-x-1">
                    {p.isPopular && <i className="fa-solid fa-fire text-zbeach-gold text-xs" title="Popüler" />}
                    {p.isNew && <i className="fa-solid fa-sparkles text-zbeach-turquoise text-xs" title="Yeni" />}
                    {p.isChefRecommended && <i className="fa-solid fa-utensils text-zbeach-dark text-xs" title="Şef" />}
                  </td>
                  <td className="p-3 text-right space-x-2">
                    <button onClick={() => { setEditing(p); setShowForm(true); }} className="text-zbeach-turquoise hover:underline text-xs" data-testid={`product-edit-${p.id}`}>Düzenle</button>
                    <button onClick={() => del(p.id)} className="text-red-600 hover:underline text-xs" data-testid={`product-delete-${p.id}`}>Sil</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {showForm && editing && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => setShowForm(false)}>
          <form onSubmit={save} onClick={(e) => e.stopPropagation()} className="bg-zbeach-surface rounded-3xl p-6 w-full max-w-3xl max-h-[92vh] overflow-y-auto" data-testid="product-form">
            <h2 className="font-serif text-2xl mb-4">{editing.id ? "Ürün Düzenle" : "Yeni Ürün"}</h2>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs uppercase tracking-wider text-zbeach-muted mb-1">Kategori *</label>
                <select required value={editing.categoryId} onChange={(e) => setEditing({ ...editing, categoryId: e.target.value })} className="w-full px-3 py-2 rounded-lg bg-zbeach-bg border border-zbeach-gold/20 text-sm" data-testid="product-category">
                  <option value="">Seçin</option>
                  {cats.map((c) => <option key={c.id} value={c.id}>{c.nameTR}</option>)}
                </select>
              </div>
              <Field label="Sıra" type="number" value={editing.sortOrder} onChange={(v) => setEditing({ ...editing, sortOrder: parseInt(v) || 0 })} />
              <Field label="Ad TR *" value={editing.nameTR} onChange={(v) => setEditing({ ...editing, nameTR: v })} required testid="product-nameTR" />
              <Field label="Ad EN" value={editing.nameEN} onChange={(v) => setEditing({ ...editing, nameEN: v })} testid="product-nameEN" />
              <Field label="Kısa Açıklama TR" value={editing.shortDescriptionTR} onChange={(v) => setEditing({ ...editing, shortDescriptionTR: v })} />
              <Field label="Kısa Açıklama EN" value={editing.shortDescriptionEN} onChange={(v) => setEditing({ ...editing, shortDescriptionEN: v })} />
              <Field label="Fiyat *" type="number" value={editing.price} onChange={(v) => setEditing({ ...editing, price: v })} required testid="product-price" />
              <Field label="İndirimli Fiyat" type="number" value={editing.discountedPrice ?? ""} onChange={(v) => setEditing({ ...editing, discountedPrice: v })} />
              <Field label="İçindekiler TR" value={editing.ingredientsTR} onChange={(v) => setEditing({ ...editing, ingredientsTR: v })} />
              <Field label="İçindekiler EN" value={editing.ingredientsEN} onChange={(v) => setEditing({ ...editing, ingredientsEN: v })} />
              <Field label="Alerjenler TR" value={editing.allergensTR} onChange={(v) => setEditing({ ...editing, allergensTR: v })} />
              <Field label="Alerjenler EN" value={editing.allergensEN} onChange={(v) => setEditing({ ...editing, allergensEN: v })} />
              <Field label="Porsiyon" value={editing.portionInfo} onChange={(v) => setEditing({ ...editing, portionInfo: v })} />
              <Field label="Hazırlanma süresi" value={editing.preparationTime} onChange={(v) => setEditing({ ...editing, preparationTime: v })} />
            </div>

            <div className="mt-3">
              <label className="block text-xs uppercase tracking-wider text-zbeach-muted mb-1">Görsel URL</label>
              <input value={editing.image || ""} onChange={(e) => setEditing({ ...editing, image: e.target.value })} className="w-full px-3 py-2 rounded-lg bg-zbeach-bg border border-zbeach-gold/20 text-sm" placeholder="https://... görsel URL'si girin veya Görsel Galerisi'nden seçin" />
              {editing.image && (
                <div className="mt-2 w-24 h-24 rounded-lg overflow-hidden bg-zbeach-sand">
                  <img src={editing.image} alt="" className="w-full h-full object-cover" />
                </div>
              )}
            </div>

            <div className="flex flex-wrap gap-4 mt-4">
              <Checkbox label="Aktif" checked={editing.isActive} onChange={(v) => setEditing({ ...editing, isActive: v })} />
              <Checkbox label="Stokta" checked={editing.isAvailable} onChange={(v) => setEditing({ ...editing, isAvailable: v })} />
              <Checkbox label="Popüler" checked={editing.isPopular} onChange={(v) => setEditing({ ...editing, isPopular: v })} />
              <Checkbox label="Şef Tavsiyesi" checked={editing.isChefRecommended} onChange={(v) => setEditing({ ...editing, isChefRecommended: v })} />
              <Checkbox label="Yeni" checked={editing.isNew} onChange={(v) => setEditing({ ...editing, isNew: v })} />
              <Checkbox label="Vegan" checked={editing.isVegan} onChange={(v) => setEditing({ ...editing, isVegan: v })} />
              <Checkbox label="Vejetaryen" checked={editing.isVegetarian} onChange={(v) => setEditing({ ...editing, isVegetarian: v })} />
              <Checkbox label="Glutensiz" checked={editing.isGlutenFree} onChange={(v) => setEditing({ ...editing, isGlutenFree: v })} />
              <Checkbox label="Acılı" checked={editing.isSpicy} onChange={(v) => setEditing({ ...editing, isSpicy: v })} />
            </div>

            <VariantManager editing={editing} setEditing={setEditing} field="variants" label="Varyasyonlar (örn. küçük/orta/büyük)" />
            <VariantManager editing={editing} setEditing={setEditing} field="extras" label="Ekstralar (örn. ekstra shot)" />

            <div className="flex justify-end gap-2 mt-5">
              <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 rounded-full bg-zbeach-bg text-zbeach-muted text-sm">İptal</button>
              <button type="submit" className="px-5 py-2 rounded-full bg-zbeach-turquoise text-white text-sm font-medium" data-testid="product-save">Kaydet</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

const VariantManager = ({ editing, setEditing, field, label }) => {
  const items = editing[field] || [];
  const update = (idx, key, val) => {
    const next = [...items];
    next[idx] = { ...next[idx], [key]: val };
    setEditing({ ...editing, [field]: next });
  };
  const add = () => setEditing({ ...editing, [field]: [...items, { id: crypto.randomUUID(), nameTR: "", nameEN: "", extraPrice: 0, isActive: true }] });
  const remove = (idx) => setEditing({ ...editing, [field]: items.filter((_, i) => i !== idx) });
  return (
    <div className="mt-4 border-t border-zbeach-gold/15 pt-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-serif text-base text-zbeach-dark">{label}</h3>
        <button type="button" onClick={add} className="text-xs text-zbeach-turquoise hover:underline">+ Ekle</button>
      </div>
      {items.map((it, idx) => (
        <div key={it.id || idx} className="grid grid-cols-12 gap-2 mb-2 items-center">
          <input value={it.nameTR} onChange={(e) => update(idx, "nameTR", e.target.value)} placeholder="Ad TR" className="col-span-4 px-2 py-1.5 rounded bg-zbeach-bg border border-zbeach-gold/20 text-sm" />
          <input value={it.nameEN} onChange={(e) => update(idx, "nameEN", e.target.value)} placeholder="Ad EN" className="col-span-4 px-2 py-1.5 rounded bg-zbeach-bg border border-zbeach-gold/20 text-sm" />
          <input type="number" value={it.extraPrice} onChange={(e) => update(idx, "extraPrice", parseFloat(e.target.value) || 0)} placeholder="+₺" className="col-span-2 px-2 py-1.5 rounded bg-zbeach-bg border border-zbeach-gold/20 text-sm" />
          <label className="col-span-1 text-xs"><input type="checkbox" checked={it.isActive} onChange={(e) => update(idx, "isActive", e.target.checked)} /> A</label>
          <button type="button" onClick={() => remove(idx)} className="col-span-1 text-red-600 text-xs">×</button>
        </div>
      ))}
    </div>
  );
};

export default Products;
